import React, { Component } from 'react';
import AudioAnalyser from './AudioAnalyser';

class Visualizer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audio: null,
    };
    this.toggleMicrophone = this.toggleMicrophone.bind(this);
  }

  componentDidMount() {

  }

  async getMicrophone() {
    const audio = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });
    this.setState({ audio });
  }

  stopMicrophone() {
    this.state.audio.getTracks().forEach((track) => track.stop());
    this.setState({ audio: null });
  }

  toggleMicrophone() {
    if (this.state.audio) {
      this.stopMicrophone();
    } else {
      this.getMicrophone();
    }
  }

  render() {

    return (
      <div className="App" key={this.props.liveMic}>
        <div className="controls">
          <button onClick={this.toggleMicrophone}>
            {this.state.audio ? 'Stop microphone' : 'Get microphone input'}
          </button>
        </div>
        <div>
          {this.state.audio ? <AudioAnalyser audio={this.state.audio} /> : ''}
        </div>
      </div>
    );
  }
}

export default Visualizer;
